import { render, staticRenderFns } from "./SupportTicketView.vue?vue&type=template&id=b6f45eb2&scoped=true"
import script from "./SupportTicketView.vue?vue&type=script&lang=js"
export * from "./SupportTicketView.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketView.vue?vue&type=style&index=0&id=b6f45eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f45eb2",
  null
  
)

export default component.exports